/**
 * Dashboard API
 * =============
 * API module for dashboard statistics.
 */

import apiClient from './client';

const dashboardAPI = {
  getStats: (params = {}) => apiClient.get('/api/v1/dashboard/stats', { params }),
};

export default dashboardAPI;
